import script from "./Govid.vue?vue&type=script&setup=true&lang=js"
export * from "./Govid.vue?vue&type=script&setup=true&lang=js"

import "./Govid.vue?vue&type=style&index=0&id=3cc9f493&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cc9f493"]])

export default __exports__